import { FormValidator } from '~/modules';

export default FormValidator.object().shape({
  username: FormValidator.string().required('Nome do usuário obrigatório'),
  password: FormValidator.string().required('Senha obrigatória'),
});
